import React from 'react';
import './Layout.css';

function Layout({ children }) {
  return (
    <div className="App">
      <div className="App-content">{children}</div>
    </div>
  );
}

export default Layout;
